export default "__VITE_ASSET__Cl5K0Nwt__"